import * as React from 'react'
import styled from 'styled-components'

import * as ds from '@bob/design-system'

import { State } from './hooks/useArchives'

type ArchiveSectionProps = { archives: State }

export function ArchiveSection({ archives }: ArchiveSectionProps) {
  return (
    <Archive>
      <ds.Container>
        <ds.stickers.others.Archives />
        <ArchiveBody>
          <ds.styles.heading.Title4>
            C’est vraiment bien ? <br /> Jetez un œil à nos archives !
          </ds.styles.heading.Title4>
          <ds.styles.heading.Title2>
            C’est vraiment bien ? <br /> Jetez un œil à nos archives !
          </ds.styles.heading.Title2>
          <List>
            {archives.status === 'success' &&
              archives.list.map((entry, index) => {
                return (
                  <ListItem key={entry.id}>
                    <ds.styles.copy.TextArticle>
                      {new Date(entry.updated_at).toLocaleString('fr', { day: '2-digit', month: '2-digit' })}
                    </ds.styles.copy.TextArticle>
                    <ds.BlobBackground variant={((index % 5) + 1) as any} color="yellow" />
                    <ds.styles.copy.Text5>
                      <a href={entry.url}>{entry.subject}</a>
                    </ds.styles.copy.Text5>
                  </ListItem>
                )
              })}
          </List>
          <LinkWrapper>
            📗{' '}
            <ds.Link href="https://bit.ly/bob_ebook_antigreenwashing" target="_blank" rel="noreferrer">
              <ds.styles.copy.Text5>Télécharger notre petit guide anti greenwashing</ds.styles.copy.Text5>
            </ds.Link>
          </LinkWrapper>
        </ArchiveBody>
      </ds.Container>
    </Archive>
  )
}

const List = styled.ul`
  ${ds.styles.copy.Text5} {
    font-weight: 400;
    text-decoration: underline;
  }
`

const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  position: relative;
  margin-bottom: 15px;

  ${ds.styles.copy.TextArticle} {
    margin-right: 15px;
    position: relative;
    z-index: 1;
  }

  ${ds.BlobBackground} {
    opacity: 0;
    position: absolute;
    width: 35px;
    height: 35px;
    top: -3px;
    left: -11px;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover {
    ${ds.BlobBackground} {
      opacity: 1;
    }
  }
`

const Archive = styled.section`
  background-color: ${ds.color.PINK};
  position: relative;
  margin-top: 70px;

  ${ds.stickers.others.Archives} {
    width: 115px;
    height: 115px;
    position: absolute;
    top: -40px;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    margin-top: 185px;

    ${ds.stickers.others.Archives} {
      width: 164px;
      height: 164px;
    }
  }
`

const ArchiveBody = styled.div`
  padding: 50px 20px;
  max-width: 624px;
  margin: 0 auto;

  ${ds.styles.heading.Title4} {
    display: none;
    text-align: center;
    line-height: 68px;
    margin: 0 0 40px;
  }

  ${ds.styles.heading.Title2} {
    margin: 40px 0 40px;
  }

  @media screen and (${ds.breakpoint.TABLET}) {
    ${ds.styles.heading.Title4} {
      display: block;
    }
    ${ds.styles.heading.Title2} {
      display: none;
    }
    padding: 70px 0;
  }
`

const LinkWrapper = styled.div`
  display: flex;
  align-items: baseline;
  margin-top: 50px;

  ${ds.Link} {
    margin-left: 10px;
  }
`
